
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "form": {
    "modules": []
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}

import cfg0 from "/opt/actions-runner/_work/Apex/Apex/frontend/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
